import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import { useReportAuth } from '../context/ReportAuthContext';

const STEPS = [
  { id: 1, text: 'Validating payment',       delay: 800  },
  { id: 2, text: 'Contacting PPSR register', delay: 2000 },
  { id: 3, text: 'Generating your report',   delay: 3500 },
];

export default function Processing() {
  //console.log('processing page help me');
  //console.log('40');
  
  const navigate = useNavigate();

  //console.log('AGAIN: navigate(/Report, { replace: true });');
  navigate('/Report');
  const { hasValidToken } = useReportAuth();
//console.log('41');
  const [activeStep, setActiveStep] = React.useState(0);
  const timerRef = useRef([]);
//console.log('42');
  useEffect(() => {
    if (!hasValidToken) {
      navigate('/', { replace: true });
      return;
    }

    //console.log('navigate(/Report, { replace: true });');
    //navigate('/Report', { replace: true });

    //console.log('42');
    const timers = timerRef.current;

    //console.log('43 steps');
    // Animate through steps
    STEPS.forEach((step, idx) => {
      //console.log(`Step ${idx + 1}: ${step.text}`);
      const t = setTimeout(() => setActiveStep(idx + 1), step.delay);
      timers.push(t);
    });

    //console.log('44 Navigate to Report');
    // Redirect to report after all steps complete
    const redirect = setTimeout(() => {
      //console.log('45 Navigating to Report');
      navigate('/Report', { replace: true });
    }, 5000);
    timers.push(redirect);

    return () => timers.forEach(clearTimeout);
  }, [hasValidToken, navigate]);

  return (
    <>
      <Header minimal />
      <section className="processing-section">
        <div className="container">
          <div className="processing-card">
            <div className="processing-spinner">
              <i className="fas fa-spinner fa-spin"></i>
            </div>
            <h1>Processing Your Report</h1>
            <p>Please wait while we retrieve your PPSR data. This usually takes a few seconds.</p>

            <div className="processing-steps">
              {STEPS.map((step, idx) => (
                <div
                  key={step.id}
                  className={`processing-step${activeStep > idx ? ' step-complete' : ''}${activeStep === idx ? ' step-active' : ''}`}
                >
                  <div className="step-indicator">
                    {activeStep > idx ? (
                      <i className="fas fa-check-circle"></i>
                    ) : (
                      <span>{step.id}</span>
                    )}
                  </div>
                  <span>{step.text}</span>
                </div>
              ))}
            </div>

            <div className="processing-warning">
              <i className="fas fa-exclamation-triangle"></i>
              <span>Do not close or refresh this page</span>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
